/* @flow */

import Immutable from 'immutable';
import { equal } from '../util/equal';

function bindSelectors(property: string, selectors: Object): Object {
  return Object.keys(selectors).reduce((methods, name) => {
    if (typeof selectors[name] === 'function') {
      methods[name] = function() {
        var args = [...arguments];
        if (args[0] instanceof Immutable.Map) {
          args[0] = args[0].get(property);
        }
        return selectors[name](...args);
      };
    }
    return methods;
  }, {});
}

function memoize(fn: Function): Function {
  let lastState = null;
  let cache = Object.create(null);

  return function(state: Object, ...args: any[]) {
    const key = args.join('\0');
    var lastValue;

    if (state !== lastState) {
      // flush cache
      lastState = state;
      lastValue = cache[key];
      cache = Object.create(null);
    }

    if (!cache[key]) {
      // compute and store
      var nextValue = fn.apply(this, arguments);
      cache[key] = equal(nextValue, lastValue) ? lastValue : nextValue;
    }

    // return from cache
    return cache[key];
  };
}

function memoizeSelectors(selectors: Object): Object {
  return Object.keys(selectors).reduce((selectors, name) => {
    if (typeof selectors[name] === 'function') {
      selectors[name] = memoize(selectors[name]);
    }
    return selectors;
  }, Object.create(selectors));
}

export {
  memoize,
  memoizeSelectors,
  bindSelectors
};
